/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Features_TitleInputs */

const en_gc_resources_features_title = /** @type {(inputs: Gc_Resources_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Familiar tools. An open foundation.`)
};

const zh_gc_resources_features_title = /** @type {(inputs: Gc_Resources_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熟悉的工具，开放的底层。`)
};

/**
* | output |
* | --- |
* | "Familiar tools. An open foundation." |
*
* @param {Gc_Resources_Features_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_features_title = /** @type {((inputs?: Gc_Resources_Features_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Features_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_features_title(inputs)
	return zh_gc_resources_features_title(inputs)
});
export { gc_resources_features_title as "gc.resources.features.title" }